"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSharedInfo = void 0;
const utils_1 = require("./utils");
class GetSharedInfo {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() { }
    static getInstance() {
        return new GetSharedInfo();
    }
    getDomElement() {
        return utils_1.originReference.domElement;
    }
    getStore() {
        return utils_1.originReference.store;
    }
    getHistory() {
        return utils_1.originReference.history;
    }
    getInitializedFeatures() {
        return utils_1.originReference.initializedFeatures;
    }
    getExternalComponents() {
        return utils_1.originReference.externalComponents;
    }
    getData() {
        return utils_1.originReference.data;
    }
}
exports.GetSharedInfo = GetSharedInfo;
//# sourceMappingURL=getSharedInfo.js.map